import React, { useEffect, useState } from 'react';
import './Website.css';

import graduation from './images/graduation.jpg';
import f from './images/facebook.png';
import x from './images/x.png';
import instagram from './images/instagram.png';

import ismail from './images/ismail.jpg';
import ismail2 from './images/ismail2.jpg';

import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { useNavigate } from 'react-router-dom';

import ktc_banner from './images/ktcbannar.png';
import g_zaki from './images/gudoomiyezaki.jpeg';

import KtcHeader from './Ktcheader';
import KtcMyFooter from './ktc_my_footer.js';

const KtcElearnigHomePage = () => {

  const navigate = useNavigate();

  const [Facults, setFacults] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [our_student, setOurStudent] = useState([]);

  const apiKey = "3f72ef31838a6cf7e082718614350592a56d06a57ba48e1206addf949b1734bd662265d87239cbd582ae3be050606943";

  // =====================================================================
  // 🚀 FIXED useEffect: Safe, error-handled, no invalid logs
  // =====================================================================
  useEffect(() => {

    const fetchData = async () => {
      try {
        // Faculties
        const facRes = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-facults`,
          { headers: { "x-api-key": apiKey } }
        );

        setFacults(facRes.data?.report || []);

        // Departments
        const depRes = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/getlink-apikey/web-departments`,
          { headers: { "x-api-key": apiKey } }
        );

        setDepartments(depRes.data?.report || []);

      } catch (err) {
        console.error("❌ Error loading API data:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="website-container">

        {/* HEADER */}
        <KtcHeader />

        {/* BANNER */}
        <section className="hero-banner">
          <img src={ismail} className="hero-iframe" alt="Banner" />
        </section>

        {/* MAIN BODY */}
        <main className="main-content">

          {/* Why E-learning Section */}
          <section className="why-e-learning-section">
            {[
              { icon: "🎓", title: "Why E-learning", text: "We offer fully online and hybrid courses including Diploma, Bachelor." },
              { icon: "🌐", title: "Vision Statement", text: "Inspiring community engagement and inclusive learning environments." },
              { icon: "🏠", title: "Mission Statement", text: "Providing flexible support services, research, and training." },
              { icon: "📖", title: "Our Commitments", text: "Leading digital learning innovation." }
            ].map((item, i) => (
              <div className="why-card" key={i}>
                <div className="card-icon">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.text}</p>
              </div>
            ))}
          </section>

          {/* Welcome Section */}
          <section className="welcome-section">
            <div className="welcome-image">
              <img src={ismail} alt="UNISO" />
            </div>
            <div className="welcome-text-container">
              <div className="about-e-learning-header">ABOUT E-LEARNING</div>
              <h2>Welcome to University of Somalia</h2>

              <p>
               Welcome to the illustrious University of Somalia (UNISO) and thank you for visiting E-learning website. UNISO was founded by a group of dedicated Somali scholars and is committed to the development of human potential to contribute to the implementation of Somali national development plans. UNISO will serve the Somali nation by providing its students with world-class and relevant knowledge, skills, and ethical and moral training necessary for the 21st Century.It will strive to employ qualified, experienced and talented faculty capable and willing to provide UNISO students with the knowledge, insights, tools and techniques they need to realize their full potential and become productive Somali citizens. For over a decade, UNISO has been home to bright educators, aspiring students, and others who have been drawn from all over Somalia. We currently have the largest programs in health science, business administration and computer science in Mogadishu and we are striving to achieve national, regional and international recognition.UNISO encourages its faculty and students to be responsible intellectuals and to engage their communities in academic research to advance knowledge and seek effective solutions to the sociopolitical and economic issues that currently confront our nation. We invite qualified faculty and talented Somali students to visit our university campuses and join the growing community of scholars at UNISO.
              </p>

              <p className="signature">All the best.</p>
              <p className="signature">Eng Zaki Yusuf</p>
            </div>
          </section>

          {/* Faculties Section */}
          <section className="faculties-section">
            <div className="section-header">
              <h3>KTC Faculties</h3>
              <div className="header-line"></div>
            </div>

            <div className="faculties-list">

              {Facults.length === 0 && <p>Loading faculties...</p>}

              {Facults.map((faculty, index) => (
                <div className="faculty-card" key={index}>

                  <img
                    src={`${API_URL}/${faculty?.image?.replace("public/", "")}`}
                    alt={faculty?.name}
                  />

                  <div className="faculty-info">
                    <h4>{faculty?.name}</h4>
                    <p>{faculty?.facult_count} Programs</p>
                  </div>

                </div>
              ))}

            </div>
          </section>

          {/* Programs Section */}
          <section className="popular-programs-section">
            <div className="section-header">
              <div className="header-line"></div>
              <h3>Popular Programs</h3>
              <div className="header-line"></div>
            </div>

            <div className="programs-list">

              {departments.length === 0 && <p>Loading programs...</p>}

              {departments.map((department, index) => (
                <div className="program-card" key={index}>
                  <div className="program-image">
                    <img
                      src={`${API_URL}/${department?.image?.replace("public/", "")}`}
                      alt={department?.name}
                    />

                    <div className="program-actions">
                      <button
                        className="action-link"
                        onClick={() => navigate(`/department/${department.id}`)}
                      >
                        Read More
                      </button>

                      <a
                        className="action-link"
                        href={`portal/register-online_student?course_id=${department.id}`}
                      >
                        Apply Now
                      </a>
                    </div>
                  </div>

                  <h4>{department?.name}</h4>

                  <div className="program-details">
                    <span>
                      🕒 {department?.duration} Month
                    </span>
                  </div>

                </div>
              ))}

            </div>
          </section>

        </main>

        {/* FOOTER */}
        <KtcMyFooter />

      </div>
    </>
  );
};

export default KtcElearnigHomePage;
